<template>
  <div class="container-fluid resource-calendar-page" :class="{ 'resource-calendar-page--page-scroll': pageScroll }">
    <div class="row d-flex h-100">
      <div class="col-lg-12 d-flex flex-column">
        <card class="card-calendar flex-grow-1 d-flex flex-column">
          <resource-calendar-view @page-scroll="pageScroll = $event"></resource-calendar-view>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/pages/Layout/LoadingMainPanel";

const ResourceCalendarView = () => ({
  component: import('./Bookings/ResourceCalendar/ResourceCalendarView.vue'),
  loading: Loading,
  delay: 100
});

export default {
  name: "ResourceCalendarPage",
  components: {
    ResourceCalendarView
  },
  data() {
    return {
      // Month below 992px: the view reports it, and the page drops its fixed height (OTC-2955)
      pageScroll: false
    }
  }
}
</script>

<style scoped>
.resource-calendar-page {
  height: calc(100vh - 110px);
  display: flex;
  flex-direction: column;
}

.resource-calendar-page .row {
  flex: 1;
  min-height: 0;
}

.resource-calendar-page .col-lg-12 {
  height: 100%;
}

.card-calendar {
  margin-bottom: 0;
  height: 100%;
}

.card-calendar :deep(.card-body) {
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}

.card-calendar :deep(.resource-calendar) {
  height: 100%;
  flex: 1;
}

/* Month below 992px lays out at its natural height and the page scrolls (OTC-2955) */
.resource-calendar-page--page-scroll,
.resource-calendar-page--page-scroll .col-lg-12,
.resource-calendar-page--page-scroll .card-calendar,
.resource-calendar-page--page-scroll .card-calendar :deep(.card-body),
.resource-calendar-page--page-scroll .card-calendar :deep(.resource-calendar) {
  height: auto;
}
/* The row carries Bootstrap's h-100 (height: 100% !important) */
.resource-calendar-page--page-scroll .row {
  flex: none;
  height: auto !important;
}
</style>
